export default [
  {
    title: 'Two columns',
    content: '<div class="columns mceTmpl is-multiline"><div class="column is-6 is-12-mobile"><p>column 1</p></div><div class="column is-6 is-12-mobile"><p>column 2</p></div></div>',
    description: 'Adds Editor 2 Columns'
  },
  {
    title: 'Three columns',
    content: '<div class="columns mceTmpl is-multiline"><div class="column is-4 is-12-mobile"><p>column 1</p></div><div class="column is-4 is-12-mobile"><p>column 2</p></div><div class="column is-4 is-12-mobile"><p>column 3</p></div></div>',
    description: 'Adds Editor 4 Columns'
  },
  {
    title: 'Four columns',
    content: '<div class="columns mceTmpl is-multiline"><div class="column is-3 is-12-mobile"><p>column 1</p></div><div class="column is-3 is-12-mobile"><p>column 2</p></div><div class="column is-3 is-12-mobile"><p>column 3</p></div><div class="column is-3 is-12-mobile"><p>column 4</p></div></div>',
    description: 'Adds Editor 3 Columns'
  },
  {
    title: 'Four and Eight column',
    content: '<div class="columns mceTmpl is-multiline"><div class="column is-8 is-12-mobile"><p>column 1</p></div><div class="column is-4 is-12-mobile"><p>column 2</p></div></div>',
    description: 'Adds Editor 8 column to the left and 4 to the right Columns'
  }, {
    title: 'Eight and Four column',
    content: '<div class="columns mceTmpl is-multiline"><div class="column is-4 is-12-mobile"><p>column 1</p></div><div class="column is-8 is-12-mobile"><p>column 2</p></div></div>',
    description: 'Adds Editor 4 column to the left and 8 to the right Columns'
  }, {
    title: 'Quarter, Quarter, and two quarters',
    content: '<div class="columns mceTmpl is-multiline"><div class="column is-3 is-12-mobile"><p>column 1</p></div><div class="column is-3 is-12-mobile"><p>column 2</p></div><div class="column is-6 is-12-mobile"><p>column 1</p></div></div>',
    description: 'Adds Editor 3 columns 1/4 , 1/4 and 2/4'
  }, {
    title: 'Two quarters, quarter and quarter',
    content: '<div class="columns mceTmpl is-multiline"><div class="column is-6 is-12-mobile"><p>column 1</p></div><div class="column is-3 is-12-mobile"><p>column 1</p></div><div class="column is-3 is-12-mobile"><p>column 2</p></div></div>',
    description: 'Adds Editor 3 columns 50% to the left and 50%/2 columns to the right'
  }, {
    title: 'Three quarters and quarter',
    content: '<div class="columns mceTmpl is-multiline"><div class="column is-9 is-12-mobile"><p>column 1</p></div><div class="column is-3 is-12-mobile"><p>column 1</p></div></div>',
    description: 'Adds Editor 2 columns 75% to the left and 25% to the right'
  }, {
    title: 'Two quarters, quarter and quarter',
    content: '<div class="columns mceTmpl is-multiline"><div class="column is-3 is-12-mobile"><p>column 1</p></div><div class="column is-9 is-12-mobile"><p>column 1</p></div></div>',
    description: 'Adds Editor 2 columns 25% to the left and 75% to the right'
  }, {
    title: 'Map',
    content: "<iframe src='         {{ path('site-map') }}' style='width: 100%; height: 250px; overflow: hidden; border: none'/>",
    description: 'Adds Map'
  }
]
